module.exports = __webpack_public_path__ + "img/search.6f44e507.png";